import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-automative',
    templateUrl: './automative.component.html',
    styleUrls: ['./automative.component.scss'],
    standalone: false
})
export class AutomativeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
